// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7dbb89eb","695":"7cb56770","977":"dbd9614f"}[chunkId] + ".chunk.js";
};